import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EFilterJsonQueryActionType {
  SetJsonQuery = 'filterJsonQuery/setJsonQuery',
}

export type TSetJsonQuery = ITypedReduxAction<EFilterJsonQueryActionType.SetJsonQuery, object>;

export type TFilterJsonQueryActions = TSetJsonQuery;
